var map = {
	"./menu/main.sync.js": "./js/src/preact-components/menu/main.sync.js",
	"./widget-last-visitors/LastVisitors.sync.js": "./js/src/preact-components/widget-last-visitors/LastVisitors.sync.js"
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "./js/src/preact-components eager recursive ^\\.\\/.*\\.sync\\.js$ exclude: (server%7C\\.(spec%7Ctest)\\.tsx?$%7Csettings%7Ctheme-configuration%7Cadmin-toolbar%7C\\.lazy)";
module.exports = webpackAsyncContext;